import React, { Component } from 'react';
import { createValidator, required, match, password } from '../../../../helpers/validator';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import TextField from '../../Fields/TextField';
import Button from '../../Controls/Button';

const validator = createValidator({
  newPassword: [required, password],
  confirmedNewPassword: [required, match('newPassword', 'New Password')],
});

export const resetPasswordFormId = 'resetPassword';

class ResetPasswordForm extends Component {
  render() {
    const { error, handleSubmit, pristine, reset, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit} className="ml-2 mr-2">
        <Field
          name="newPassword"
          component={TextField}
          type="password"
          label="New Password"
          showLabel={true}
          required={true}
          disabled={submitting}
          
        />
        <Field
          name="confirmedNewPassword"
          component={TextField}
          type="password"
          label="Confirm New Password"
          showLabel={true}
          required={true}
          disabled={submitting}
          
        />
        {error && (
          <div className="my-2 text-left">
            <span className="form-error">{error}</span>
          </div>
        )}
        <hr />
        <Button
          type="submit"
          size="lg"
          className="btn btn-secondary btn-lg btn-block bg-gradient-theme-left border-0"
          disabled={pristine}
          loading={submitting}
        >
          Reset Password
        </Button>
      </form>
    );
  }
}

ResetPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

ResetPasswordForm = reduxForm({
  form: resetPasswordFormId,
  validate: validator,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(ResetPasswordForm);

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);
